<template>
  <div>
    <!-- <div
      v-if="innerWidth >= 1600"
      class="d-flex align-items-center justify-content-center"
    >
      <b-img
        :src="subscriptionImageMap['con-cura-all']"
        alt="Piani Sottoscrizione"
        style="width: 100%"
      />
    </div> -->
    <!-- <div v-else class="d-flex align-items-center justify-content-center"> -->
    <div class="">
      <template
        v-if="subscription && subscriptionImageMap[subscription] != undefined"
      >
        <b-img
          fluid
          center
          :src="subscriptionImageMap[subscription]"
          alt="sottoscrizione"
        />
      </template>
      <!-- <template v-else>
        <b-img
          :src="subscriptionImageMap['con-cura-all']"
          alt="sottoscrizione"
        />
      </template> -->
      <template v-else>
        <b-row class="mb-4">
          <h4
            :class="showBase ? null : 'collapsed'"
            :aria-expanded="showBase ? 'true' : 'false'"
            aria-controls="sottoscrizioni_base"
            class="text-secondary text-left point"
            @click="showBase = !showBase"
          >
            Sottoscrizioni Base
            <b-icon :icon="showBase ? 'chevron-up' : 'chevron-down'"></b-icon>
          </h4>
          <b-collapse id="sottoscrizioni_base" v-model="showBase" class="mt-2">
            <b-img
              fluid
              :src="subscriptionImageMap['con-cura-base-25']"
              alt="sottoscrizione"
            />
          </b-collapse>
        </b-row>
        <b-row class="mb-4">
          <h4
            :class="showAvanzate ? null : 'collapsed'"
            :aria-expanded="showAvanzate ? 'true' : 'false'"
            aria-controls="sottoscrizioni_avanzate"
            class="text-secondary text-left point"
            @click="showAvanzate = !showAvanzate"
          >
            Sottoscrizioni Avanzate
            <b-icon
              :icon="showAvanzate ? 'chevron-up' : 'chevron-down'"
            ></b-icon>
          </h4>
          <b-collapse
            id="sottoscrizioni_avanzate"
            v-model="showAvanzate"
            class="mt-2"
          >
            <b-img
              fluid
              :src="subscriptionImageMap['con-cura-avanzate-25']"
              alt="sottoscrizione"
            />
          </b-collapse>
        </b-row>
        <b-row class="mb-4">
          <h4
            :class="showMonitoraggio ? null : 'collapsed'"
            :aria-expanded="showMonitoraggio ? 'true' : 'false'"
            aria-controls="sottoscrizioni_monitoraggio"
            class="text-secondary text-left point"
            @click="showMonitoraggio = !showMonitoraggio"
          >
            Sottoscrizioni Monitoraggio
            <b-icon
              :icon="showMonitoraggio ? 'chevron-up' : 'chevron-down'"
            ></b-icon>
          </h4>
          <b-collapse
            id="sottoscrizioni_monitoraggio"
            v-model="showMonitoraggio"
            class="mt-2"
          >
            <b-img
              fluid
              :src="subscriptionImageMap['con-cura-monitoraggio-25']"
              alt="sottoscrizione"
            />
          </b-collapse>
        </b-row>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionDetailModal",
  props: ["subscription"],
  data() {
    return {
      innerWidth: window.innerWidth,
      subscriptionImageMap: {
        "con-cura-free": require("@/assets/common/free.svg"),
        "con-cura-monitor-24": require("@/assets/common/ConCura-Monitoraggio.svg"),
        "con-cura-smart-24": require("@/assets/common/ConCura-Smart.svg"),
        "con-cura-easy-24": require("@/assets/common/ConCura-Easy.svg"),
        "con-cura-all": require("@/assets/common/Centro-Servizi-ConCura-4.svg"),
        "con-cura-easy-25": require("@/assets/common/easy.svg"),
        "con-cura-monitor-25": require("@/assets/common/monitoring.svg"),
        "con-cura-smart-25": require("@/assets/common/smart.svg"),
        "con-cura-caregiving-25": require("@/assets/common/caregiving.svg"),
        "con-cura-family-25": require("@/assets/common/family.svg"),
        "con-cura-vip-25": require("@/assets/common/vip.svg"),
        "con-cura-doc-25": require("@/assets/common/doc.svg"),
        "con-cura-base-25": require("@/assets/common/base.svg"),
        "con-cura-avanzate-25": require("@/assets/common/avanzate.svg"),
        "con-cura-monitoraggio-25": require("@/assets/common/monitoraggio.svg"),
        'con-cura-easy-maggio-25': require('@/assets/common/con-cura-easy-maggio-25.svg'),
        'con-cura-smart-maggio-25': require('@/assets/common/con-cura-smart-maggio-25.svg'),
        'con-cura-family-maggio-25': require('@/assets/common/con-cura-family-maggio-25.svg'),
        'con-cura-vip-maggio-25': require('@/assets/common/con-cura-vip-maggio-25.svg'),
        //TODO VERIFICARE CORRETTEZZA IMMAGINI SINGOLE CAREGIVING E FREE ED EVENTUALMENTE SOVRASCRIVERLE
        'con-cura-doc-maggio-25': require('@/assets/common/con-cura-doc-maggio-25.svg'),
      },
      showBase: false,
      showAvanzate: false,
      showMonitoraggio: false,
    };
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .price_huge_font,
  .fs-5 {
    /* display: block; */
    text-align: right;
    margin-top: 1rem;
  }
}
</style>
